<template lang="pug">
  .container-outlay-package.container-padding(v-loading="loading")
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item(:to="detailURL") 营销账户详情
          el-breadcrumb-item 余额转换
    c-box
      el-form(:model="accountDetail", label-position="right", label-width="200px")
        el-form-item(label="营销账户可用余额")
          .huge.bold {{ accountDetail.account_amount | toYuan }}
    c-box
      el-form(:model="$data", label-position="right", label-width="200px")
        el-row(:gutter="10")
          el-col(:span="12")
            el-form-item(label="转换类型")
              el-select(v-model="package_id", @change="selectPackage")
                el-option(v-for="p in packageList", :key="p.id", :value="p.id", :label="p.biz_type | biz_type")
            el-form-item(label="转换金额（￥）")
              el-input-number(v-model="purchase_count")
          el-col(:span="12")
            el-form-item(label="", v-if="currentPackage.biz_type === 2") {{ currentPackage.price }} 元 = {{ currentPackage.count * 100 }} 积力宝
            el-form-item(label="", v-else-if="currentPackage.biz_type === 3") {{ currentPackage.price }} 元 = {{ currentPackage.count }} 现金券
        el-form-item
          template(slot="label")
            template(v-if="currentPackage.biz_type === 2") 获取积力宝
            template(v-if="currentPackage.biz_type === 3") 获取现金券
          template 
            template(v-if="currentPackage.biz_type === 2") {{ $math.round(purchase_count * currentPackage.count * 100, 2) }}
            template(v-if="currentPackage.biz_type === 3") {{ purchase_count * currentPackage.count }}
        el-form-item(label="消耗余额") {{ purchase_count }} 元
        el-form-item(label="应用订单号或标识") 系统在充值成功后将通知授权的应用，该标识可用于授权的应用识别充值转换记录，请与授权的应用方沟通获得。
        el-form-item(label="")
          el-input(v-model="outer_bill_id")
      .align-center
        el-button(type="primary", @click="savePackage") 确定
</template>

<script>
export default {
  data () {
    return {
      accountDetail:  {},
      packageList:    [],
      currentPackage: {
        count:  0,

      },

      package_id:     null,
      purchase_count: 0,
      outer_bill_id:  null,

      loading:        false,
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
    detailURL () {
      return `/outlay/${this.outlay_account_id}`;
    }
  },
  filters: {
    biz_type (source) {
      switch (source) {
        case  1:  return '余额';
        case  2:  return '积力宝';
        case  3:  return '现金券';
        default:  return source;
      }
    },
  },
  methods: {
    selectPackage (id) {
      const p = this.packageList.find((v) => {
        return id === v.id;
      });

      this.package_id = p.id;
      this.currentPackage = p || {};
      this.purchase_count = 0;

      return p;
    },
    savePackage () {
      if (!this.purchase_count || this.purchase_count <= 0) {
        this.$message({
          type:     'warning',
          message:  `转换金额应大于 0`,
        });
        return;
      }

      this.loading = true;
      return this.$store.dispatch('OUTLAY_ACCOUNT_PURCHASE_APPLY', {
        package_id:         this.package_id,
        outlay_account_id:  this.outlay_account_id,
        purchase_count:     parseInt(this.purchase_count * 100),
        outer_bill_id:      this.outer_bill_id,
      }).then(() => {
        this.$alert('余额转换成功。', {
          type:     'success',
        }).then(() => {
          this.$router.push(this.detailURL);
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `余额转换失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.loading = false;
      });
    },

    getAccountDetail () {
      const account_id = this.outlay_account_id;

      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_DETAIL', account_id).then((data) => {
        this.accountDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取账户信息失败。${code}：${msg}`,
        });
      });
    },
    getPackageList () {
      return this.$store.dispatch('GET_PURCHASE_PACK_LIST', {
        limit:  50,
        offset: 0,
        stat:   true,
      }).then((data) => {
        this.packageList = data.list || [];
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取余额转换方式失败。${code}：${msg}`,
        });
      });
    },
  },
  mounted () {
    this.getAccountDetail();
    this.getPackageList().then(() => {
      if (this.packageList.length > 0) {
        this.selectPackage(this.packageList[0].id);
      }
    });
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-outlay-package {
  .flex-content {
    .flex(center, flex-start, row);

    .display-block {
      margin-left:  1em;
    }
  }
}
</style>
